import React from "react";
import { Communications } from "./Communications";
import { SpendAlerts } from "./SpendAlerts";
import { usePanel } from "./org/shared";
import { Account, PasswordSection } from "./Account";
import { AgentControls } from "./Overview";
import { Page, type Layer } from "../design";
import type { AuthHeaders } from "../lib/auth";
import type { Me, Org } from "../lib/types";

const TABS = [
  { key: "profile", label: "Profile", icon: "account" },
  { key: "agent", label: "Agent & privacy", icon: "lock" },
  { key: "password", label: "Password", icon: "keys" },
  { key: "notifications", label: "Notifications", icon: "mail" },
] as const;

type Tab = (typeof TABS)[number]["key"];

const LAYERS: Layer<Tab>[] = TABS.map((t) => ({
  value: t.key,
  label: t.label,
  icon: t.icon,
  group: "Account",
}));

export function Settings({
  me,
  org,
  authHeaders,
  refresh,
}: {
  me: Me;
  org?: Org | null;
  authHeaders: AuthHeaders;
  refresh: () => Promise<void>;
}) {
  const [tab, setTab] = usePanel(
    TABS.map((t) => t.key),
    "profile",
  );

  return (
    <Page
      title="Account"
      layers={{
        value: tab,
        options: LAYERS,
        onChange: setTab,
      }}
    >
      {tab === "profile" && <Account me={me} org={org} hideHeader />}
      {tab === "agent" && (
        <AgentControls me={me} authHeaders={authHeaders} refresh={refresh} />
      )}
      {tab === "password" && <PasswordSection />}
      {tab === "notifications" && (
        <>
          <SpendAlerts authHeaders={authHeaders} />
          <Communications
            me={me}
            authHeaders={authHeaders}
            refresh={refresh}
            hideHeader
          />
        </>
      )}
    </Page>
  );
}
